import Component from '../Component';

export default class Parallax extends Component {
  constructor(theme, element) {
    super(theme, element);

    this.theme = theme;
    this.element = element;
    this.el_height = this.element.clientHeight;
    this.img = this.element.querySelector('.img');
    this.placeholder_svg = this.img.querySelector('.icon--placeholder');
    this.img_styles = window.getComputedStyle(this.img);
    this.active = false;

    // Wait for image load
    var self = this;
    var imgBgimage = this.img_styles.getPropertyValue('background-image');

    if(imgBgimage && imgBgimage !== 'none') {
      var imageUrl = imgBgimage.slice(4, -1).replace(/["']/g, '');
      var image = document.createElement('img');
      image.src = imageUrl;

      image.onload = function(e) {
        self.onWindowResize();
        self.img.style.display = 'block';
      };
    }
    else if(this.placeholder_svg) {
      this.onWindowResize();
      this.img.style.display = 'block';
    }

    window.addEventListener('scroll', this.update.bind(this), {
      capture: true,
      passive: true
    });
  }

  onWindowResize = () => {
    var imgMinHeight = this.img_styles.getPropertyValue('min-height');
    var multiplier = parseFloat(imgMinHeight) / 100.0;
    this.img_height = this.el_height * multiplier;

    this.container_height =
      (this.element.clientHeight > 0
        ? this.element.clientHeight
        : this.img_height) || 500;

    // Parallax is disabled on mobile
    this.active = !window.matchMedia('screen and (max-width: 767px)').matches;
    this.update();
  };

  update = () => {
    if (!this.active) {
      this.img.style.transform = '';

      if(this.placeholder_svg) {
        this.placeholder_svg.style.height = 'auto';
      }

      return;
    }

    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var parallax_dist = this.img_height - this.container_height;
    var top = this.element.getBoundingClientRect().top + scrollTop;
    var bottom = top + this.container_height;
    var windowHeight = window.innerHeight;
    var windowBottom = scrollTop + windowHeight;
    var percentScrolled = (windowBottom - top) / (this.container_height + windowHeight);
    var parallax = parallax_dist * percentScrolled;

    if(this.placeholder_svg) parallax = parallax * 2;

    if (bottom > scrollTop && top < scrollTop + windowHeight) {
      this.img.style.transform = 'translate3D(-50%,' + parallax + 'px, 0)';
    }
  };
}
